import React, { useState, useCallback } from 'react'
import { Modal, Button, Typography, Input, message } from 'antd'
import { PRESCRIPTION_ACTIONS } from '../../../constants'

const { Text } = Typography

const Detail = ({ header, children, style = {} }) => (
    <div style={{ display: 'flex', width: '100%', flexDirection: 'column', justifyContent: 'space-between', ...style }}>
        {header && <Text style={{ marginRight: '10px', fontSize: '.75rem', textTransform: 'capitalize' }}>{header}</Text>}
        {children}
    </div>
)

export const PrescriptionActionModal = ({
    prescription,
    action,
    handler,
    provider,
    deselectRx,
    isAdmin
}) => {
    const [PIN, setPIN] = useState('')
    const handleAction = useCallback(async () => {
        const PINRequirementFulfilled = !provider?.pinSet || PIN.length === 4
        
        if (action === PRESCRIPTION_ACTIONS.RESEND) {
            if (isAdmin && provider?.pinSet) {
                return message.error('Provider has PIN set, cannot resend prescription as an admin')
            }
            if (!PINRequirementFulfilled) {
                return message.error('PIN is required to resend prescription')
            }
            const success = await handler({ prescriptionId: prescription.prescriptionId, PIN, providerId: provider._id })
            if (success) {
                message.success('Prescription resent successfully')
                deselectRx()
            }
            setPIN('')
        } else if ([PRESCRIPTION_ACTIONS.DELETE, PRESCRIPTION_ACTIONS.CANCEL].includes(action)) {
            const success = await handler(prescription.prescriptionId, provider?._id)
            if (success) {
                const actionText = action === PRESCRIPTION_ACTIONS.DELETE ? 'deleted' : 'cancelled'
                message.success(`Prescription ${actionText} successfully`)
                deselectRx()
            }
        }
    }, [action, handler, prescription, provider, PIN, isAdmin, deselectRx])

    const buttonType = action === PRESCRIPTION_ACTIONS.CANCEL ? 'danger' : 'primary'
    const showPINInput = action === PRESCRIPTION_ACTIONS.RESEND && provider?.pinSet
    
    const footer = [
        <div key="footer" style={{ display: 'flex', justifyContent: showPINInput ? 'space-between' : 'flex-end' }}>
            {showPINInput && (
                <div>
                    PIN: 
                    <Input
                        id="prescription-action-pin-input"
                        style={{ width: '75px', marginLeft: '10px', textTransform: 'capitalize' }}
                        maxLength={4}
                        type="password"
                        size="small"
                        value={PIN}
                        onChange={e => setPIN(e.target.value)}
                    />
                </div>
            )}
            <Button 
                id="prescription-action-submit-btn"
                style={{ textTransform: 'capitalize' }} 
                key="submit" 
                type={buttonType} 
                size="small" 
                disabled={action === PRESCRIPTION_ACTIONS.RESEND && showPINInput && PIN.length < 4}
                onClick={handleAction}
            >
                {action} Rx
            </Button>
        </div>
    ]
    
    return (
        <Modal
            title={<div style={{ textTransform: 'capitalize' }}>{action} Prescription?</div>}
            open={true}
            centered
            width={280}
            onCancel={deselectRx}
            footer={footer}
            maskClosable={true}
            destroyOnClose={true}
            getContainer={false}
        >
            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                <Detail header='Drug Name'>
                    <div style={{ width: '100%', fontWeight: 'bolder', fontSize: '.75rem' }}>{prescription.name}</div>
                </Detail>
                <Detail header='Strength' style={{ flexDirection: 'column' }}>
                    <div style={{ fontWeight: 'bolder', fontSize: '.75rem' }}>{prescription.strength || 'See above'}</div>
                </Detail>
                <Detail header='Quantity' style={{ flexDirection: 'column' }}>
                    <div style={{ fontWeight: 'bolder', fontSize: '.75rem' }}>{prescription.quantity}</div>
                </Detail>
                <Detail header='Refills' style={{ flexDirection: 'column' }}>
                    <div style={{ fontWeight: 'bolder', fontSize: '.75rem' }}>{prescription.refills}</div>
                </Detail>
                <Detail header='Days Supply' style={{ flexDirection: 'column' }}>
                    <div style={{ fontWeight: 'bolder', fontSize: '.75rem' }}>{prescription.daysSupply}</div>
                </Detail>
                <Detail header='Directions'>
                    <div style={{ fontWeight: 'bolder', fontSize: '.75rem' }}>{prescription.directions}</div>
                </Detail>
            </div>
        </Modal>
    )
}
